export default __webpack_public_path__ + "static/media/4 a.ba065cc8.png";